import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function ExecutiveLeadershipTeam({ executiveLeadershipTeam = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "name", label: "Name" },
        { key: "tenure", label: "Tenure" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "name", label: "Name" },
        { key: "role", label: "Role" },
        { key: "tenure", label: "Tenure" },
        { key: "notes", label: "Notes" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     name: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     role: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     tenure: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     notes: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     name_positive_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_negative_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_recent_development: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     role_positive_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_negative_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_recent_development: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     tenure_positive_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_negative_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_recent_development: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     notes_positive_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_negative_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_recent_development: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //   },
  //   {
  //     name: {
  //       value: "John Smith",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.88,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     role: {
  //       value: "Chief Financial Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.9,
  //       reasoning: "Confirmed via company announcements.",
  //     },
  //     tenure: {
  //       value: "3 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.82,
  //       reasoning: "Derived from employment history.",
  //     },
  //     notes: {
  //       value: "Implemented cost-saving initiatives; previously with Deloitte.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Based on board meeting summaries.",
  //     },
  //     name_positive_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_negative_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_recent_development: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     role_positive_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_negative_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_recent_development: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     tenure_positive_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_negative_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_recent_development: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     notes_positive_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_negative_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_recent_development: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //   },
  //   {
  //     name: {
  //       value: "Alice Johnson",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Internal HR verified.",
  //     },
  //     role: {
  //       value: "Chief Operating Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.93,
  //       reasoning: "Reflected in recent press release.",
  //     },
  //     tenure: {
  //       value: "7 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.86,
  //       reasoning: "Confirmed from HR records.",
  //     },
  //     notes: {
  //       value: "Oversaw global supply chain restructuring.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from performance reports.",
  //     },
  //     name_positive_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_negative_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_recent_development: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     role_positive_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_negative_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_recent_development: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     tenure_positive_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_negative_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_recent_development: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     notes_positive_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_negative_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_recent_development: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //   },
  //   {
  //     name: {
  //       value: "Bob Williams",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Confirmed from org chart.",
  //     },
  //     role: {
  //       value: "Chief Technology Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.91,
  //       reasoning: "Published in company blog.",
  //     },
  //     tenure: {
  //       value: "2 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.84,
  //       reasoning: "Pulled from onboarding date.",
  //     },
  //     notes: {
  //       value: "Introduced AI-driven analytics platform.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.83,
  //       reasoning: "Based on product launch report.",
  //     },
  //     name_positive_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_negative_insight: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     name_recent_development: {
  //       value: "Jane Doe",
  //       source: "https://placeholder.source.com",
  //       data_type: "Profile",
  //       confidence_score: 0.9,
  //       reasoning: "Verified through internal HR system.",
  //     },
  //     role_positive_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_negative_insight: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     role_recent_development: {
  //       value: "Chief Executive Officer",
  //       source: "https://placeholder.source.com",
  //       data_type: "Role",
  //       confidence_score: 0.95,
  //       reasoning: "Confirmed via company org chart.",
  //     },
  //     tenure_positive_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_negative_insight: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     tenure_recent_development: {
  //       value: "5 years",
  //       source: "https://placeholder.source.com",
  //       data_type: "Duration",
  //       confidence_score: 0.85,
  //       reasoning: "Derived from employment records.",
  //     },
  //     notes_positive_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_negative_insight: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //     notes_recent_development: {
  //       value: "Former VP at XYZ Corp; led turnaround strategy in 2022.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Note",
  //       confidence_score: 0.8,
  //       reasoning: "Summary based on leadership briefing notes.",
  //     },
  //   },
  // ];

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(
      executiveLeadershipTeam
    );
    setTabData(transformed);
    // setTableBelowDescription(
    //   <ParsedTextWithLinks
    //     text={
    //       executiveLeadershipTeam?.[0]?.response[
    //         "distribution_positioning_summary"
    //       ] || ""
    //     }
    //   />
    // );
  }, [executiveLeadershipTeam]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Executive Leadership Team"
      data={tabData}
      metrics={columns}
      rowIdentifier="name"
      actions={actions}
    />
  );
}

export default ExecutiveLeadershipTeam;
